import { TableRow } from "@tiptap/extension-table";

export const CustomTableRow = TableRow.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      "data-row-id": {
        default: null,
        parseHTML: (element) => element.getAttribute("data-row-id"),
        renderHTML: (attributes) => {
          if (!attributes["data-row-id"]) {
            return {};
          }
          return { "data-row-id": attributes["data-row-id"] };
        },
      },
    };
  },
});
